/* Canonical outbound links to the Factory OS app. Keeping them in one place
   means the request-access destination (and any tier context) changes here,
   not across a dozen call sites. */

export const APP_URL = 'https://app.factory-os.com';
export const REQUEST_ACCESS_URL = `${APP_URL}/request-access`;
export const SIGN_IN_URL = `${APP_URL}/login`;

const TIER_SLUG = {
  Free: 'free',
  Team: 'team',
  'Founding Partner': 'founding-partner',
  Enterprise: 'enterprise',
};

/* app.factory-os.com/request-access, with ?tier=<slug> when a plan context
   is known so the app can preselect it. Unknown/no tier → the bare URL. */
export function requestAccessUrl(tier) {
  const slug = tier && TIER_SLUG[tier];
  return slug ? `${REQUEST_ACCESS_URL}?tier=${slug}` : REQUEST_ACCESS_URL;
}
